<template>
  <page-view :title="false">
    <div class="map-container">
      <!-- 二维码 -->
      <div class="qr-code">
        <vue-qr
          :text="qrUrl"
          :logoSrc="logo"
          :logoCornerRadius="10"
          :callback="qrCallBack"
          qid="testid"
        ></vue-qr>
      </div>
      <div class="search-box">
        <div class="nav-bar">
          <label>状态：</label>
          <a-radio-group v-model="queryParam.rentSta" @change="radioChange">
            <a-radio value="">全部</a-radio>
            <a-radio value="0">空置房源</a-radio>
            <a-radio value="2">在租房源</a-radio>
          </a-radio-group>
        </div>
        <div class="nav-bar">
          <label>类型：</label>
          <a-radio-group v-model="queryParam.searchType" @change="radioChange">
            <a-radio value="">全部</a-radio>
            <a-radio value="1">单间次卧</a-radio>
            <a-radio value="2">独卫主卧</a-radio>
            <a-radio value="3">整租</a-radio>
          </a-radio-group>
        </div>
      </div>

      <el-amap
        class="amap-box"
        ref="map"
        :vid="'amap-vue'"
        :amap-manager="amapManager"
        :events="events"
      >
        <el-amap-marker
          :topWhenClick="true"
          :key="index"
          :vid="index"
          v-for="(marker, index) in markers"
          :position="marker.position"
          :visible="marker.visible"
          :draggable="marker.draggable"
          :events="marker.events"
        >
          <div @click="markerClick(marker.data)">
            <span class="marker-tooltip">{{ marker.title }}</span>
            <img :src="image" style="width: 20px;" />
          </div>
        </el-amap-marker>
      </el-amap>

      <div class="list-panel" v-if="show">
        <div class="title">
          <span class="span">{{ currentData.communityName }}</span>
          <div class="opts">
            <a style="margin-right:10px;" @click="exportQr('community')"
              >小区房源二维码</a
            >
            <!-- <a style="margin-right:10px;" @click="exportQr('merchant')"
              >商家主页二维码</a
            > -->
            <a @click="closeShow">关闭</a>
          </div>
        </div>
        <div style="padding: 0 10px;overflow-y: auto;height: 90%;">
          <a-list
            rowKey="h1"
            class="demo-loadmore-list"
            item-layout="vertical"
            :data-source="houseList"
          >
            <a-list-item
              slot="renderItem"
              slot-scope="item, index"
              :key="index"
            >
              <template slot="actions" v-if="item.rentSta == '2'">
                <a @click="copy(item)">分享链接</a>
                <a-popconfirm
                  title="确认上架?"
                  @confirm="upDownHouse(item, 'up')"
                  okText="确认"
                  cancelText="取消"
                  ><a>上架</a></a-popconfirm
                >
                <a @click="goModifyHouse(item)">编辑</a>
              </template>
              <template slot="actions" v-if="item.rentSta == '0'">
                <a @click="copy(item)">分享链接</a>
                <a-popconfirm
                  title="确认下架?"
                  @confirm="upDownHouse(item, 'down')"
                  okText="确认"
                  cancelText="取消"
                  ><a>下架</a></a-popconfirm
                >
                <a @click="goModifyHouse(item)">编辑</a>
              </template>
              <a-list-item-meta
                :description="
                  item.payWayName +
                    ' | ' +
                    item.rent +
                    '(元/月)' +
                    ' | ' +
                    item.roomLayoutName +
                    ' | ' +
                    item.rentTypeName +
                    ' | ' +
                    item.roomDirection
                "
              >
                <span slot="title">{{ item.houseName }}</span>
              </a-list-item-meta>
            </a-list-item>
          </a-list>
          <div style="text-align: center;">
            <a-button
              v-if="totalPage > 0"
              @click="loadMore"
              :loading="loadingMore"
              >{{ loadingText }}</a-button
            >
          </div>
        </div>
      </div>
    </div>
  </page-view>
</template>

<script>
import VueAMap from "vue-amap";
import { PageView } from "@/layouts";
import { h5Copy } from "../../../utils/util.js";
import VueQr from "vue-qr";
let amapManager = new VueAMap.AMapManager();
export default {
  name: "HouseMap",
  components: {
    PageView,
    VueQr
  },
  data() {
    return {
      amapManager,
      events: {
        init: o => {
          // console.log(o.getCenter());
          // console.log(this.$refs.map.$$getInstance());
          o.getCity(result => {
            // console.log(result);
          });
          // o.setMapStyle("fresh");//改变样式
        },
        moveend: () => {},
        zoomchange: () => {},
        click: e => {}
      },
      image: require("@/assets/house.png"),
      userInfo: null,
      queryParam: {
        rentSta: "",
        searchType: "",
        merchantNo: "",
        isBackstageMapSearch: "T"
      },
      markers: [],
      pageSize: 10,
      pageNumber: 1,
      totalPage: 0,
      houseList: [],
      loadingText: "加载更多",
      loadingMore: false,
      currentData: {},
      show: false,

      logo: "",
      qrUrl: "",
      isCreate: false,
      merchant: {
        logo: "",
        name: "",
        no: ""
      }
    };
  },
  created() {
    this.userInfo = this.$store.getters.userInfo;
    if (this.userInfo.merchantNo) {
      this.merchant.no = this.userInfo.merchantNo;
      this.queryParam.merchantNo = this.userInfo.merchantNo;
      this.queryList();

      //获取商户logo
      let merchantInfo = this.userInfo.merchant.merchantInfo;
      this.merchant.name = merchantInfo.merchantName;
      if (merchantInfo && merchantInfo.logo) {
        this.merchant.logo = merchantInfo.logo;
      }
    }
  },
  methods: {
    qrCallBack(dataUrl, id) {
      if (this.isCreate) {
        this.isCreate = false;
        var a = document.createElement("a");
        a.href = dataUrl;
        a.download = "qrcode" + new Date().getTime();
        a.click();
        setTimeout(() => {
          this.logo = "";
          this.qrUrl = "";
        }, 300);
      }
    },
    radioChange() {
      this.closeShow();
      this.queryList();
    },
    queryList() {
      this.$http.roomBksApi.listCommunityMarker(this.queryParam).then(res => {
        if (res.result == 0) {
          let arr = [];
          for (let m of res.resultObject) {
            let marker = {};
            marker.position = [m.longitude, m.latitude];
            marker.visible = true;
            marker.draggable = false;
            marker.icon = this.image;
            marker.title = m.communityName + "(" + m.total + "套)";
            marker.data = m;
            arr.push(marker);
          }
          this.markers = arr;
        }
      });
    },
    markerClick(data) {
      if (this.currentData.communityCode == data.communityCode) {
        return;
      }
      this.currentData = Object.assign({}, data);
      this.show = true;
      this.pageNumber = 1;
      this.loadingText = "加载更多";
      this.queryHouseList(this.currentData);
    },
    queryHouseList(data) {
      let searchParam = {};
      searchParam.pageSize = this.pageSize;
      searchParam.firstResult = (this.pageNumber - 1) * this.pageSize;
      searchParam.communityCode = data.communityCode;
      searchParam.merchantNo = this.userInfo.merchantNo;
      searchParam.rentSta = this.queryParam.rentSta;
      searchParam.searchType = this.queryParam.searchType;
      this.$http.roomBksApi.pageHouseInfo(searchParam).then(res => {
        if (res.result == 0) {
          this.formattingData(res);
        }
      });
    },
    formattingData(res) {
      let list = res.resultObject.datas;
      if (this.pageNumber == 1) {
        this.houseList = [];
        this.houseList = list;
      } else {
        this.houseList = this.houseList.concat(list);
      }
      this.setTotalPage(res.resultObject.totalRows);
    },
    setTotalPage(total) {
      let x = parseInt(total / this.pageSize);
      let y = total % this.pageSize;
      if (y == 0) {
        this.totalPage = x;
      } else {
        this.totalPage = x + 1;
      }
    },
    loadMore() {
      this.pageNumber = this.pageNumber + 1;
      if (this.pageNumber > this.totalPage) {
        this.loadingText = "数据全部加载完成";
        return;
      }
      this.queryHouseList(this.currentData);
    },
    copy(item) {
      let url =
        "https://www.xuroom.com/mobile/pages/pub/house_detail?houseNo=" +
        item.houseNo;
      const result = h5Copy(url);
      if (result === true) {
        this.$message.success("链接复制成功");
      }
    },
    closeShow() {
      this.show = false;
      this.houseList = [];
      this.currentData = {};
    },
    exportQr(type) {
      this.isCreate = true;
      this.qrUrl =
        "https://www.xuroom.com/merchant?merchantNo=" +
        this.merchant.no +
        "&merchantName=" +
        this.merchant.name +
        "&logo=" +
        this.merchant.logo;
      if (type == "merchant") {
        this.logo = this.merchant.logo;
      } else {
        this.logo = "";
        this.qrUrl =
          this.qrUrl + "&communityCode=" + this.currentData.communityCode;
      }
    },
    //上/下架
    upDownHouse(item, type) {
      const param = {};
      param.type = type;
      param.houseNo = item.houseNo;
      this.$http.roomBksApi.saveUpDownHouseInfo(param).then(res => {
        if (res.result == 0) {
          this.queryList();
          this.markerClick(this.currentData);
          this.$message.success(res.msg);
        }
      });
    },
    goModifyHouse(info) {
      // this.$router.push({
      //   name: "ModifyHouse",
      //   query: {
      //     houseNo: info.houseNo,
      //     keeperNo: info.keeperNo,
      //     type: "map"
      //   }
      // });

      const page = this.$router.resolve({
        path: "/house/houseList/modifyHouse",
        query: { houseNo: info.houseNo, keeperNo: info.keeperNo, type: "map" }
      });

      window.open(page.href, "_blank");
    }
  }
};
</script>
<style lang="less" scoped>
.map-container {
  width: 100%;
  height: 80vh;
  position: relative;
}
.marker-tooltip {
  display: block;
  background-color: #13c2c2;
  padding: 3px 6px;
  color: #fff;
  text-decoration: none;
  word-wrap: break-word;
  white-space: nowrap;
  // border-radius: 2px;
  font-size: 10px;
}

.search-box {
  display: flex;
  flex-direction: column;
  position: absolute;
  right: 0;
}
.nav-bar {
  padding: 0 10px;
  height: 50px;
  line-height: 50px;
  background-color: rgba(255, 255, 255, 0.8);
  // position: absolute;
  // top: 0;
  // right: 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  // justify-content: center;
  z-index: 100;
}

.list-panel {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 100;
  width: 350px;
  height: 95%;
  border-radius: 10px;
  background-color: #fff;
  .title {
    display: flex;
    justify-content: space-between;
    height: 50px;
    align-items: center;
    padding: 10px;
    border-bottom: 1px solid #f2f2f2;
    .span {
      font-size: 16px;
    }
    .opts {
    }
  }
}
.qr-code {
  z-index: -100;
  position: absolute;
}
</style>
